import React, { useState } from 'react';
import { Label, Error, ClassHelper } from 'components/lib';
import Style from './input.tailwind.js';
import { UilCheck, UilEye, UilEyeSlash } from '@iconscout/react-unicons'

export function PasswordInput(props) {
  const [error, setError] = useState(
    props.errorMessage || 'Please enter a password'
  );
  const [show, setShow] = useState(false);

  function validate(e) {
    let value = e ? e.target.value : '';
    let valid = undefined;

    // input is required and value is blank
    if (props.required && value === '') valid = false;

    // input isn't required and value is blank
    if (!props.required && value === '') valid = true;

    if (props.required && value !== '') valid = true;

    if (!props.required) valid = true;

    // complexity rules
    if (props.complexPassword) {
      if (value.length < 8) {
        valid = false;
        setError('Password must be a minimum of 8 characters');
      } else if (value.length > 48) {
        valid = false;
        setError('Password can have a maximum of 48 characters');
      } else if (!/[A-Z]/.test(value)) {
        valid = false;
        setError('Password must have at least one upper case letter');
      } else if (!/[a-z]/.test(value)) {
        valid = false;
        setError('Password must have at least one lower case letter');
      }
    }

    // update the parent form
    props.onChange?.(props.name, value, valid);
  }

  const passwordStyle = ClassHelper(Style, {
    textbox: true,
    className: props.className,
    error: props.valid === false,
    success: props.valid === true,
    warning: props.warning,
  });

  return (
    <div className={Style.input}>
      {props.label && (
        <Label text={props.label} required={props.required} for={props.name} />
      )}

      <input
        type={show ? 'text' : 'password'}
        id={props.for}
        name={props.name}
        value={props.value || ''}
        placeholder={props.placeholder || ''}
        className={passwordStyle}
        style={{ border: '1px solid #D7D7D7', borderRadius: 5, backgroundColor: '#F9F9F9', paddingRight: '2.5rem' }}
        onChange={(e) =>
          props.onChange?.(props.name, e.target.value, undefined)
        }
        onBlur={(e) => validate(e)}
        maxLength={props.maxLength}
        minLength={props.minLength}
      />

      <button
        type="button"
        onClick={() => setShow(!show)}
        aria-label={show ? 'Hide password' : 'Show password'}
        style={{ position: 'absolute', top: '2.8em', right: '0.75rem', width: 'auto', marginTop: 0, cursor: 'pointer', background: 'none', border: 'none', padding: 0, display: 'flex', alignItems: 'center' }}
      >
        {show ? <UilEyeSlash size={18} color="#A0A0A0" /> : <UilEye size={18} color="#A0A0A0" />}
      </button>

      {props.valid === false && <Error message={error} />}

      {props.valid === true && (
        <UilCheck 
          color="#8CC57D"
          className={Style.successIcon}
          size={16}
          style={{ right: '2.25rem' }}
        />
      )}
    </div>
  );
}
